import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import farmSolar from "@/assets/farm-solar.png";
gsap.registerPlugin(ScrollTrigger);

export default function ServiceSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const section = sectionRef.current;
    const content = contentRef.current;
    if (!section || !content) return;

    const contentTween = gsap.fromTo(
      content,
      { y: 50, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 1,
        ease: "power3.out",
        scrollTrigger: {
          trigger: section,
          start: "top 70%",
          toggleActions: "play none none none",
        },
      }
    );

    return () => {
      contentTween.scrollTrigger?.kill();
      contentTween.kill();
    };
  }, []);

  return (
    <section ref={sectionRef} className="relative z-20 px-4 sm:px-6 md:px-10 lg:px-14 pt-16 sm:pt-20 md:pt-32 lg:pt-36 pb-12 sm:pb-16 md:pb-20">
      <div ref={contentRef} className="relative max-w-7xl mx-auto mt-6 sm:mt-8 md:mt-12">
        {/* Dark card */}
        <div className="relative z-10 rounded-[28px] sm:rounded-[40px] bg-[#0A0A0A] px-6 sm:px-8 md:px-12 lg:px-16 py-10 sm:py-12 md:py-16 lg:py-24">
          <div className="grid grid-cols-1 lg:grid-cols-[1fr_auto] gap-8 sm:gap-10 lg:gap-16 items-end">
            <div className="space-y-5 sm:space-y-6">
              <p className="text-accent-400 text-xs sm:text-sm md:text-base font-body font-medium tracking-wider uppercase">
                G2 Contracting
              </p>
              <h2 className="font-heading font-bold text-[26px] sm:text-[32px] md:text-[44px] lg:text-[56px] text-white tracking-tight leading-[1.05]">
                Energie als
                <br />
                Geschäftsmodell
              </h2>
              <p className="text-white/70 text-sm sm:text-base md:text-lg leading-relaxed max-w-xl">
                Für Hausverwaltungen und Gewerbe: Mieterstrom, Energiemanagement und dynamische Tarife — die Software-Seite von Zweering Elektrotechnik.
              </p>
            </div>
            <div className="lg:pb-1">
              <a
                href="/g2-contracting"
                className="inline-flex items-center px-6 sm:px-8 py-3.5 sm:py-4 rounded-full bg-accent-500 text-white font-body font-medium text-xs tracking-wider uppercase hover:bg-accent-600 transition-colors whitespace-nowrap"
              >
                G2 Contracting entdecken
              </a>
            </div>
          </div>
        </div>

        {/* Underlapping image */}
        <div className="relative z-0 -mt-10 sm:-mt-14 md:-mt-24 lg:-mt-32 rounded-[28px] sm:rounded-[40px] overflow-hidden">
          <img
            src={farmSolar}
            alt="Landwirtschaftsbetrieb mit Photovoltaikanlage auf dem Dach"
            width={1672}
            height={941}
            className="w-full h-auto object-cover"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
}
